export enum EmailSearchResultCategory {
  FoundEmailAssociatedWithOneCarrier = 'found_email_associated_with_one_carrier',
  FoundEmailDomainAssociatedWithOneCarrier = 'found_email_domain_associated_with_one_carrier',
  MultipleCarriers = 'multiple_carriers',
  Fraud = 'fraud',
  IdentityAlert = 'identity_alert',
  SpoofingAttempt = 'spoofing_attempt',
  DispatcherService = 'dispatcher_service',
}
